import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useWishlist } from '../context/WishlistContext';
import { useNavigate } from 'react-router-dom';
import ProductCard from '../components/ProductCard';

const Wishlist = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { wishlist, fetchWishlist } = useWishlist();

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    fetchWishlist();
  }, [user]);

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8" data-testid="wishlist-page">
      <div className="max-w-7xl mx-auto">
        <h1 className="font-heading text-4xl text-forest mb-8 tracking-tight" data-testid="wishlist-heading">My Wishlist</h1>

        {wishlist.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-muted-foreground" data-testid="empty-wishlist">Your wishlist is empty</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {wishlist.map((product) => (
              <ProductCard key={product.product_id} product={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Wishlist;